import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colors, tablet, fonts } from '../../theme';
export default {
  container: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    textAlign: 'center',
    letterSpacing: '0.05em'
  }),
  containerSmall: _objectSpread({
    letterSpacing: '0.03em'
  }, tablet({
    fontSize: '1.2rem'
  })),
  wrapper: {
    overflow: 'auto hidden',
    scrollbarWidth: 'none',
    MsOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent'
    }
  },
  links: _objectSpread({
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    margin: '0',
    textTransform: 'uppercase',
    '& li': {
      marginLeft: '1rem',
      marginRight: '1rem'
    },
    '& li:first-child': {
      marginLeft: 'auto'
    },
    '& li:last-child': {
      marginRight: 'auto'
    },
    // variants
    '$containerSmall &': {
      textTransform: 'none'
    }
  }, tablet({
    '& li': {
      marginLeft: '2rem',
      marginRight: '2rem'
    }
  })),
  link: {
    display: 'block',
    padding: '1rem',
    whiteSpace: 'nowrap',
    lineHeight: 1,
    '& span': {
      display: 'block',
      borderBottom: '1px solid transparent'
    }
  },
  linkInactive: {
    pointerEvents: 'none'
  },
  linkCurrent: {
    pointerEvents: 'none',
    '& span': {
      borderBottomColor: colors.pureBlack
    }
  }
};